module.exports = __webpack_public_path__ + "media/images/icons/piggy-bank-bf4cef73daf594a4dead07c0124e627a.svg";